var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"border",class:_vm.className},[(_vm.header)?_c('h6',{staticClass:"pt-3 pl-3"},[_vm._v(_vm._s(_vm.header))]):_vm._e(),_c('hr'),_c('ul',{class:_vm.listClass},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }